import { Component } from '@angular/core';
import { Input } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { TeamDetailsComponent } from '../team-details/team-details.component';
import { Router } from '@angular/router';
import { TeamService } from '../../team-create/team.service';
import { ToastService } from '../../services/toast.service';
import { SharedServiceService } from '../../services/shared-service.service';
import { NgIf } from '@angular/common';
@Component({
  selector: 'app-team-card',
  standalone: true,
  imports: [MatCardModule, TeamDetailsComponent, NgIf],
  templateUrl: './team-card.component.html',
  styleUrl: './team-card.component.css'
})
export class TeamCardComponent {
  @Input() teamdata: any;
  @Input() screentype: any;

  isAdmin: boolean;
  constructor(private router: Router, private toast: ToastService, private teamService: TeamService,
    private SharedService: SharedServiceService) {
    var role = this.SharedService.getloggedUserRole();


    if (role == 'Administrator') {
      this.isAdmin = true;
    }
    else if (role != 'Administrator') {
      this.isAdmin = false;
    }
}
  ngOnInit(): void {
  }
  viewTeamDetails(teamId: string) {

    this.router.navigate(['/team-edit'], {
      queryParams: {
        id: teamId
      }
    });
  }
  assignMembers(teamId: string) {

    this.router.navigate(['/members-assignment'], {
      queryParams: {
        teamId: teamId,
        IsTeamMemView: false,
        name: this.teamdata.teamName
      }
    });
  }

  deleteTeam(teamId: string) {
    this.teamService.deleteTeam(teamId).subscribe({
      next: () => {
        this.toast.successMessage('Team deleted successfully');
        this.reloadComponent();
      },
      error: (error) => {
        if (error.status === 409) {
          this.toast.errorMessage('Unable to delete this team as ' + error.error);
        } else {
          this.toast.errorMessage('Something went wrong try after page refresh ');
        }
      }
    });
  }
  reloadComponent() {
    const currentUrl = this.router.url;
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([currentUrl]);
    });
  }
  viewMember(teamId: string) {

    this.router.navigate(['/members-assignment'], {
      queryParams: {
        teamId: teamId,
        IsTeamMemView: true,
        name: this.teamdata.teamName
      }
    });
  }
}
